import React from "react";
import Routes from "./admin/routes";
import LoginProvider from "./admin/context/LoginContext";
import SiteDetailsProvider from "./admin/context/SiteDetailsContext";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
      <LoginProvider>
        <SiteDetailsProvider>
          <Routes />
        </SiteDetailsProvider>
      </LoginProvider>
    </>
  );
}

export default App;
